export const carPriceFromTI = (autoCarPrice, ownerCarPrice, ownerCarPriceEnabled) => {
  if (ownerCarPriceEnabled && ownerCarPrice > 0) {
    return ownerCarPrice
  } else {
    return autoCarPrice
  }
}
